// Достижения (UX-вайрфрейм, экран 07): два состояния — выполнено / не открыто.
// Состояние считает бэк — GET /me/achievements (эндпоинт authed-only, спека
// миграции достижений); экран только рендерит ответ. Гостю показываем инвайт
// войти вместо списка — своей логики вычисления достижений здесь больше нет.

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { loadAchievements, type AchievementsResponse } from '@/api/achievements';
import { useAuth } from '@/auth/authStore';
import { LOCKED_ART } from '@/meta/lockedArt';
import { BottomNav } from '@/meta/Shell';

export function AchievementsScreen() {
  const auth = useAuth();
  const [data, setData] = useState<AchievementsResponse | null>(null);

  useEffect(() => {
    if (auth.status !== 'authed') return;
    let cancelled = false;
    loadAchievements().then((d) => { if (!cancelled) setData(d); }).catch(() => {});
    return () => { cancelled = true; };
  }, [auth.status]);

  const items = auth.status === 'authed' ? (data?.achievements ?? null) : null;
  const done = items?.filter((a) => a.done).length ?? 0;

  return (
    <main className="meta-screen" data-testid="screen-achievements">
      <header className="meta-subbar">
        <h1>Достижения</h1>
        {items && (
          <span className="counter" data-testid="ach-counter">{done} / {items.length}</span>
        )}
      </header>
      <div className="meta-body">
        {auth.status === 'guest' && (
          <div className="guest-box" data-testid="guest-box">
            <p className="hint" style={{ color: 'var(--ink)' }}>
              Войдите, чтобы отслеживать достижения
            </p>
            <Link to="/login" className="btn btn-sm btn-accent" data-testid="login-link">
              Войти
            </Link>
          </div>
        )}
        {auth.status !== 'guest' && !items && <p>Загрузка…</p>}
        {auth.status !== 'guest' && items && (
          <div className="ach-list">
            {items.map((a) => (
              <div
                key={a.id}
                className={a.done ? 'ach-row' : 'ach-row off'}
                data-testid={`ach-${a.id}`}
                data-done={a.done || undefined}
              >
                <span className="ach-ico" aria-hidden="true">
                  {a.done ? a.icon : <img src={LOCKED_ART} alt="" />}
                </span>
                <span><b>{a.title}</b><span className="desc">{a.desc}</span></span>
                <span className={a.done ? 'pill done' : 'pill off'}>
                  {a.done ? 'Выполнено' : 'Не открыто'}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
      <BottomNav />
    </main>
  );
}
